import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ClientService } from 'app/services/client.service';
import { Client } from 'app/models/client.models';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-proveedor-dialog',
  templateUrl: './proveedor-dialog.component.html',
})
export class ProveedorDialogComponent {
  form: FormGroup;
  proveedores: Client[] = [];
  proveedoresFiltrados: Observable<Client[]>;

  constructor(
    public dialogRef: MatDialogRef<ProveedorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private clientService: ClientService
  ) {
    this.form = this.fb.group({
      proveedorId: [data?.proveedorId || '', Validators.required]
    });
    this.clientService.getProveedores().subscribe(provs => {
      this.proveedores = provs;
      this.proveedoresFiltrados = this.form.controls.proveedorId.valueChanges.pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value?.companyName),
        map(name => name ? this._filterProveedores(name) : this.proveedores.slice())
      );
    });
  }

  displayProveedor(prov: any): string {
    return prov && prov.companyName ? prov.companyName : '';
  }

  private _filterProveedores(name: string): Client[] {
    const filterValue = name.toLowerCase();
    return this.proveedores.filter(option => option.companyName?.toLowerCase().includes(filterValue));
  }

  guardar() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  cancelar() {
    this.dialogRef.close();
  }
}
